<div class="menu-toggle">
  <i class="fas fa-bars  fa-2x" (click)="onOpen()"></i>
</div>

<div class="menu" #menu>
  <div style="display: flex; justify-content: flex-end; padding: 10px;">
    <i style="color: white; cursor: pointer;" class="fas fa-times" (click)="onClose()"></i>
  </div>
  <h3 class="menu-item" (click)="onNavigate('products')">Services</h3>
  <h3 class="menu-item" (click)="onNavigate('team')">Our Team</h3>
  <h3 class="menu-item" (click)="onNavigate('gallery')">Gallery</h3>
  <h3 class="menu-item" (click)="onNavigate('hours')">Hours</h3>
  <h3 class="menu-item" (click)="onNavigate('contact')">Contact Us</h3>
  <h3 class="menu-item" (click)="onNavigate('about')">About</h3>
  <h3 class="menu-item" (click)="onNavigate('location')">Map</h3>
</div>


<div #top style="display: flex; flex-direction: column; justify-content: center; overflow-x: clip;">
  <app-header (onScroll)="triggerScroll($event)"></app-header>

  <div class="second-row">
    <div #team class="team">
      <app-team></app-team>
    </div>
    <div #products class="products">
      <app-products></app-products>
    </div>
  </div>

  <div #gallery></div>
  <app-gallery></app-gallery>

  <div style="padding: 0 20px; justify-content: space-between;" class="break-panel-wide">
    <div class="container">
      <div class="hours" #hours>
        <app-hours></app-hours>
      </div>

      <div class="contact" #contact>
        <app-contact></app-contact>
      </div>
    </div>
    <div class="about" #about>
      <app-about></app-about>
    </div>

  </div>

  <div #location></div>
  <app-location></app-location>

  <app-footer (onScroll)="triggerScroll($event)"></app-footer>
</div>
<div class="hidden-layer" #other (click)="onClose()"></div>